function YError (msg) {
  this.name = 'YError'
  this.message = msg || 'yargs error'
  Error.captureStackTrace(this, YError)
}

YError.prototype = Object.create(Error.prototype)
YError.prototype.constructor = YError

module.exports = YError



//////////////////
// WEBPACK FOOTER
// ./node_modules/yargs/lib/yerror.js
// module id = 56
// module chunks = 0